const importData = () => {
  document.getElementById("file-input").click();
};

export default importData;